<h1 mat-dialog-title>Why Can't I Sign?</h1>
<div mat-dialog-content>
    <h3>The {{ data.documentName }} is one of the last documents you will sign for the vehicle.</h3>
    <p *ngIf="numberOfDocsPending() == 1">The pending document is:</p>
    <p *ngIf="numberOfDocsPending() != 1">The pending documents are:</p>
    <p class="pendingDoc" *ngIf="getDealerPendingDocsNumber() > 0">{{ getDealerPendingDocsNumber() }} document(s) for dealer.</p>
    <p class="pendingDoc" *ngIf="getBuyerPendingDocsNumber() > 0">{{ getBuyerPendingDocsNumber() }} document(s) for buyer.</p>
    <p class="pendingDoc" *ngIf="getCoBuyerPendingDocsNumber() > 0">{{ getCoBuyerPendingDocsNumber() }} document(s) for Co-Buyer.</p>
</div>
<div class="ok-wrap">
    <button mat-button class="primary" (click)="ok()" type="submit">Ok</button>
</div>
